import { AppKitNetwork } from '@reown/appkit/networks'
import { createAppKit } from '@reown/appkit/react'
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi'
import { raise } from '@sparkdotfi/common-universal'
import { avalanche } from 'viem/chains'
import { Config } from 'wagmi'

import { SUPPORTED_CHAINS } from '../chain/constants'
import { getTransports } from './getTransports'
import { createWagmiStorage } from './storage'

export function getConfig(): Config {
  const customRpcUrls = getTransports()
  const networks = [
    ...SUPPORTED_CHAINS.filter(
      (chain) => import.meta.env.VITE_FEATURE_AVALANCHE_SUPPORT === '1' || chain.id !== avalanche.id,
    ),
  ] as AppKitNetwork[]
  const storage = createWagmiStorage()
  const projectId = import.meta.env.VITE_WALLET_CONNECT_ID || raise('Missing VITE_WALLET_CONNECT_ID')

  const wagmiAdapter = new WagmiAdapter({
    networks,
    projectId,
    customRpcUrls,
    storage,
  })

  createAppKit({
    adapters: [wagmiAdapter],
    networks: networks as [AppKitNetwork, ...AppKitNetwork[]],
    projectId,
    allowUnsupportedChain: true,
    themeMode: 'light',
    featuredWalletIds: [
      'c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96', // MetaMask
      '18388be9ac2d02726dbac9777c96efaac06d744b2f6d580fccdd4127a6d01fd1', // Rabby
      '8a0ee50d1f22f6651afcae7eb4253e52a3310b90af5daef78a8c4929a9bb99d4', // Binance
      '971e689d0a5be527bac79629b4ee9b925e82208e5168b733496a09c0faed0709', // OKX
      '38f5d18bd8522c244bdd70cb4a68e0e718865155811c043f052fb9f1c51de662', // Bitget
    ],
    // Reown dashboard settings takes precedence over the features object
    features: {
      analytics: import.meta.env.VITE_ENV_NAME === 'production',
      swaps: false,
      onramp: false,
      email: false,
      socials: false,
    },
    metadata: {
      name: 'Spark',
      description: 'Maximize your DeFi experience with transparent rates',
      url: 'https://app.spark.fi',
      icons: ['https://app.spark.fi/spark-meta-logo.png'],
    },
  })

  return wagmiAdapter.wagmiConfig
}
